import {Component, OnInit} from '@angular/core';
import {AuthService} from "./services/auth.service";
import {ChatService} from "./services/chat.service";
import {ModalController, Platform, ToastController} from "@ionic/angular";
import {NavigationService} from "./services/navigation.service";
import { NotificationService } from './services/notification.service';
import { PushNotification } from './models/push-notification.model';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public isIOSToastPwa = false;
  public isShowAnimateIOSToastPwa = false;

  constructor(
    private readonly swUpdate: SwUpdate,
    private readonly platform: Platform,
    private readonly notificationService: NotificationService,
    private readonly chatService: ChatService,
    private readonly toastController: ToastController,
    private readonly modalCtrl: ModalController,
    private readonly auth: AuthService,
    private readonly navigationService: NavigationService
  ) {}

  private readonly VAPID_PUBLIC_KEY = environment.webpushVapidKey;

  ngOnInit(): any {
    this.notificationService.notification.subscribe(notification => this.onNotification(notification));

    // this.notificationService.requestWebpushSubscriptionIfNot({ serverPublicKey: this.VAPID_PUBLIC_KEY });
    if (this.auth.isAuthenticated) {
      this.initWebpush();
      this.initSignalR();
    }

    this.auth.isAuthenticated$.subscribe(resp => {
      if (resp) {
        this.initWebpush();
        this.initSignalR();
      }
      else {
        this.notificationService.unsubscribeWebpush();
      }
    })

    // Временное решение по очистке кэша
    window.caches.keys().then(async keys => await Promise.all(keys.map(key => caches.delete(key))));

    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm("Доступна новая версия. Загрузить?")) {
          window.location.reload();
        }
      });
    }

    const isPWAInstalledOnDesktop: boolean = document.getElementsByClassName('plt-pwa').length > 0;
    if (this.platform.is('ios') && !isPWAInstalledOnDesktop) {
      if (localStorage.getItem('isIOSToastPwa'))
      { return this.isIOSToastPwa = false; }
      this.isIOSToastPwa = true;
      setTimeout(() => this.isShowAnimateIOSToastPwa = true, 2000);
      localStorage.setItem('isIOSToastPwa', String(this.isIOSToastPwa));
      setTimeout(() => {
        this.isShowAnimateIOSToastPwa = false;
        setTimeout(() => this.isIOSToastPwa = false, 2000);
      }, 15000);
    }
  }

  private async initWebpush() {
    try {
      await this.notificationService.requestWebpushSubscriptionIfNot({ serverPublicKey: this.VAPID_PUBLIC_KEY });
      await this.notificationService.registerWebpushSubscription(this.auth.authInfo?.value?.validTo);
    }
    catch (err: any) {
      console.error(err);
    }
  }

  private async initSignalR() {
    await this.notificationService.signalrStartIfNot(this.auth.accessToken);
    await this.notificationService.subscribeSignalR();
  }

  private async onNotification(notification: PushNotification) {
    console.log(notification);
    switch (notification.data.notificationAlias) {
      case 'NewMessage':
        const data: any = {
          action: notification.data.actionType ? { entityId: notification.data.actionEntityId, type: Number(notification.data.actionType) } : null,
          createdAt: new Date(),
          chatId: notification.data.chatId,
          text: notification.data.text,
          userId: notification.data.userId,
          photosIds: notification.data.photosIds ? JSON.parse(notification.data.photosIds) : [],
          id: notification.data.id
        };
        this.chatService.isNewMessageNotification$.next(data);
        this.chatService.isNewChat$.next(false);
        if (!(location.pathname.split('/').some((element) => notification.data.chatId === element) || notification.data.isSilence)) {
          this.chatService.updateTotalCountMessage();
        }
        break;
      case 'MessageEdit':
        this.chatService.isUpdateMessageNotification$.next(notification.data);
        break;
    }
  }

  private toastNewMessage(toastMesssage: string): Promise<{ data?: any, role?: string }> {
    return new Promise<{ data?: any, role?: string }>(resolve => {
      this.toastController.create({
        header: 'Новое сообщение!',
        message: toastMesssage,
        duration: 5000,
        position: 'top',
        buttons: [
          { text: 'Ответить', role: 'navigate', },
          { text: 'Закрыть', role: 'cancel', },
        ],
      })
      .then(toast => { toast.present(); toast.onDidDismiss().then(res => resolve(res)); });
    });
  }

  public IOSToastPwa() {
    this.isShowAnimateIOSToastPwa = false;
    setTimeout(() => this.isIOSToastPwa = false, 2000);
  }
}
